import React, { useCallback } from 'react';
import { AnalyticsEventLocation } from '@mb/lib';
import { getUserLang } from '@mb/lib/i18n';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ScrollFabButton } from 'components/components/ScrollFabButton';
import { useIntl } from 'react-intl';
import useSWR from 'swr';
import * as Styled from './BrandsPage.styles';
import BrandLinksContainer from './containers/BrandsLinksContainer/BrandLinksContainer';
import LetterPickerContainer from './containers/LetterPickerContainer/LetterPickerContainer';
import SearchFormListener from './containers/SearchFormListener/SearchFormListener';
import { definedTranslation } from './i18n';
import {
  postFetcher,
  getSearchConfig,
  getLanguageKey,
  getUserData,
} from '../../../../../../MaterialBank/CuratedCollections/view/frontend/web/js/utils';
import { CollectionCarousel } from '../../../../../Search/view/frontend/pages/ProductSearch/containers/CollectionsCarouselContainer/CollectionCarousel';

const userLang = getUserLang();
const customer = getUserData();
const languageKey = getLanguageKey();
const searchConfig = getSearchConfig();

const BrandsPage: React.FC = () => {
  const intl = useIntl();

  const labels = {
    title: intl.formatMessage(definedTranslation.collections.title),
    button: intl.formatMessage(definedTranslation.collections.button),
  };
  const isEu = ENVIRONMENT_REGION === 'EU';

  const handleBackUpArrowClick = () => {
    window.scrollTo(0, 0);
  };

  const matches = useMediaQuery('(max-width:767px)');

  const { data, error, isLoading } = useSWR(
    `${searchConfig.siteUrl}/collection/query`,
    (url: string) =>
      postFetcher(url, {
        customer: {
          id: customer ? customer.customer_id : '',
          email: customer ? customer.email : '',
          projectId: customer ? parseInt(customer.current_project, 10) : 0,
          country: customer ? customer.country : '',
          province: customer ? customer.state : '',
        },
        siteId: searchConfig.siteId,
        lang: languageKey,
        type: ['curated_collection'],
        subtype: ['default'],
        maxResults: 12,
      }),
    { revalidateOnFocus: false, suspense: false },
  );

  const onCtaClick = useCallback(() => {
    window.location.href = isEu
      ? `/${userLang}/curatedcollections`
      : '/curatedcollections';
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!data) {
    return (
      <div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <>
      <ScrollFabButton
        onClick={handleBackUpArrowClick}
        bottom={matches ? 125 : 89}
        right={32}
      />
      <Styled.SpaceHolder>
        <CollectionCarousel
          isLoading={isLoading}
          campaigns={data.results}
          title={labels.title}
          actionLabel={labels.button}
          onSeeAllClick={onCtaClick}
          eventLocation={AnalyticsEventLocation.BRAND_PAGE}
          ctaPosition="left"
          slideLimit={12}
        />
      </Styled.SpaceHolder>
      <LetterPickerContainer />
      <BrandLinksContainer />
      <SearchFormListener />
      {/* bottom line for Sticky */}
      <div id="bottomLine"></div>
    </>
  );
};

export default BrandsPage;
